module.exports = __webpack_public_path__ + "static/media/BGImage.5f0c36a0.jpg";